// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menuSearchOption{
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
.compactSelector{
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    width: 80%;
    height: 70%;
    
}
.compactSelectorAdmin{
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    width: 100%;
    /* height: 70%;< */
    /* top :10%; */
}
.compactSelectorIcon{
    position: relative;
    display: block;
    justify-content: center;
    align-items: center;
    width: 100%;
    /* height: 70%;< */
    /* top :10%; */
}
.react-select__control{
    border-color: var(--border-table-color) !important;
    /* border-color: #ee085c; */
width: 100%;
height: 100%;
/* border-top: none !important;
border-left: none !important; */
border-radius: var(--border-radios-small);
background-color: var(--white-color) !important;
color: aliceblue !important;

letter-spacing: 1px;
 text-align: center;
}
.react-select__input,.react-select__placeholder{
    background-color: transparent !important;
    color: var(--txt-color) !important;
    border: none !important;
    outline: 0 !important;
    font-size: var(--font-size-small);
}
.react-select-container{
    outline: 0 !important;
    top: 5px;
}
.react-select-container-admin{
    background: #FFF !important;
    color: #003757;
}
.react-select-container-icon{
    background: #FFF !important;
    color: #003757;
}
.react-select__input-container,.react-select__single-value {
    color: var(--txt-color) !important;
    font-size: var(--font-size-small);
}
.react-select__indicator svg{
    color: #088eee ;
 }

.labelSelector{
    /* font-weight: bold; */
    position: absolute;
    top: -25%;
    z-index: 2;
    /* color: #eaeaea; */
    
    /* color:  #c4c4c4; */
    color: var(--main-color);
}
.labelSelectorAdmin{
    position: absolute;
    top: -30%;
    color:  #003757;
    z-index: 1;
}
.labelSelectorIcon{
    position: absolute;
    top: -30%;
    color:  #003757;
    z-index: 1;
}
.react-select__menu:hover{
    cursor: pointer;
}
.react-select__menu{
    /* border-color:#088eee !important;;
    background-color:#030915 !important ;
    color: #088eee !important; */
    color: var(--txt-color) !important;
    background-color: var(--white-color) !important;
    border: 1px solid aliceblue !important;
    align-items: center !important;
    display: flex !important;
    text-align: center !important;
    cursor: pointer;
    z-index: 3 !important;
}
.react-select__menu-list{
    width: 100% !important;

    z-index: 30 !important;
}
.react-host-select__menu-portal{
    z-index: 30 !important;

}
.Whitereact-host-select__menu-portal{
    z-index: 30 !important;
}
.react-select__option{
    border-bottom-color: rgba(255, 255, 255, 0.127) !important;
}
/***************************** SELECTOR ADMIN **************************************/

.react-select-admin__control{
    border-color: #003757 !important;
    /* border-color: #ee085c; */
width: 100%;
height: 30px !important;
border-top: none !important;
border-left: none !important;
border-radius: 5px;
border-width: 2px !important;
/* background-color: #00000029 !important; */
color: #003757 !important;

letter-spacing: 1px;
 text-align: left;
 min-height: unset !important;
 /* z-index: 999 !important; */
}
.react-select-admin__input,.react-select-admin__placeholder{
    background-color: transparent !important;
    color: #003757 !important;
    border: none !important;
    /* outline: 0 !important; */
    font-size: large !important;

}
.react-select-container-admin{
    outline: 0 !important;
    /* top: 5px; */
}

.react-select-admin__input-container,.react-select-admin__single-value {
    color: #003757 !important;
    text-align: center;
    font-size: small;
    margin-bottom: 4px;

}
.react-select-admin__indicator svg{
    color: #003757 ;
 }


.react-select-admin__menu:hover{
    cursor: pointer;
}
.react-select-admin__menu{
    border-color:#003757 !important;;
    background-color:#0065a0 !important ;
    color: aliceblue !important;
    border: 1px solid aliceblue !important;
    align-items: center !important;
    display: flex !important;
    text-align: center !important;
    cursor: pointer;
    z-index: 999 !important;
    position: absolute !important;
    /* max-height:  100px !important; */
}
.react-select-admin__menu-list{
    width: 100% !important;
}
.react-select-admin__option{
    border-bottom-color: rgba(255, 255, 255, 0.127) !important;
}


.react-select-admin__placeholder{
 color: #c4c4c4 !important;
 font-size: medium !important;
 /* margin-left:; */
}
/***************************** SELECTOR ICON **************************************/

.react-select-icon__control{
    border-color: #003757 !important;
    /* border-color: #ee085c; */
width: 100%;
height: 30px !important;
/* border-top: none !important;
border-left: none !important; */
border-radius: 5px;
border-width: 2px !important;
/* background-color: #00000029 !important; */
color: #003757 !important;

letter-spacing: 1px;
 text-align: left;
 min-height: unset !important;
 /* z-index: 999 !important; */
}
.react-select-icon__input,.react-select-icon__placeholder{
    background-color: transparent !important;
    color: #003757 !important;
    border: none !important;
    /* outline: 0 !important; */
    font-size: large !important;

}
.react-select-container-icon{
    outline: 0 !important;
    /* top: 5px; */
}

.react-select-icon__input-container,.react-select-icon__single-value {
    color: #003757 !important;
    text-align: center;
    font-size: small;
    margin-bottom: 4px;

}
.react-select-icon__indicator svg{
    color: #003757 ;
 }


.react-select-icon__menu:hover{
    cursor: pointer;
}
.react-select-icon__menu{
    border-color:#003757 !important;;
    background-color:#ffffff !important ;
    color: rgb(0, 81, 151) !important;
    border: 1px solid aliceblue !important;
    align-items: center !important;
    justify-content: center;
    display: flex !important;
    text-align: center !important;
    cursor: pointer;
    z-index: 999 !important;
    position: absolute !important;
    /* max-height:  100px !important; */
}
.react-select-icon__menu-list{
    width: 100% !important;
}
.react-select-icon__option{
    border-bottom-color: rgba(255, 255, 255, 0.127) !important;
}


.react-select-icon__placeholder{
 color: #010b2c !important;
 font-size: medium !important;
 /* margin-left:; */
}
.rowIcon:hover{
    background-color: var(--hover-color);
}

/* **************************** horizontal Movil****************************** */
@media (min-width: 500px) and (max-width: 900px) {
    /* .react-select-container-admin-gs{
        top: 2%;
    }
    .react-select-admin-gs__control{
        height: 20px !important;
    }
    .react-select-admin-gs__indicators{
        height: 20px !important;
    } */
  }
  
  /* ****************************Movil****************************** */
  @media (max-width: 500px) {
    /* .react-select-container-admin-gs{
        top: 2%;
    }
    .react-select-admin-gs__control{
        height: 20px !important;
    }
    .react-select-admin-gs__indicators{
        height: 20px !important;
    } */
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Selector.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,WAAW;;AAEf;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,kDAAkD;IAClD,2BAA2B;AAC/B,WAAW;AACX,YAAY;AACZ;+BAC+B;AAC/B,yCAAyC;AACzC,+CAA+C;AAC/C,2BAA2B;;AAE3B,mBAAmB;CAClB,kBAAkB;AACnB;AACA;IACI,wCAAwC;IACxC,kCAAkC;IAClC,uBAAuB;IACvB,qBAAqB;IACrB,iCAAiC;AACrC;AACA;IACI,qBAAqB;IACrB,QAAQ;AACZ;AACA;IACI,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,2BAA2B;IAC3B,cAAc;AAClB;AACA;IACI,kCAAkC;IAClC,iCAAiC;AACrC;AACA;IACI,eAAe;CAClB;;AAED;IACI,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,oBAAoB;;IAEpB,qBAAqB;IACrB,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,UAAU;AACd;AACA;IACI,eAAe;AACnB;AACA;IACI;;gCAE4B;IAC5B,kCAAkC;IAClC,+CAA+C;IAC/C,sCAAsC;IACtC,8BAA8B;IAC9B,wBAAwB;IACxB,6BAA6B;IAC7B,eAAe;IACf,qBAAqB;AACzB;AACA;IACI,sBAAsB;;IAEtB,sBAAsB;AAC1B;AACA;IACI,sBAAsB;;AAE1B;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0DAA0D;AAC9D;AACA,oFAAoF;;AAEpF;IACI,gCAAgC;IAChC,2BAA2B;AAC/B,WAAW;AACX,uBAAuB;AACvB,2BAA2B;AAC3B,4BAA4B;AAC5B,kBAAkB;AAClB,4BAA4B;AAC5B,4CAA4C;AAC5C,yBAAyB;;AAEzB,mBAAmB;CAClB,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;AACA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;;AAE/B;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;;AAEtB;AACA;IACI,eAAe;CAClB;;;AAGD;IACI,eAAe;AACnB;AACA;IACI,+BAA+B;IAC/B,oCAAoC;IACpC,2BAA2B;IAC3B,sCAAsC;IACtC,8BAA8B;IAC9B,wBAAwB;IACxB,6BAA6B;IAC7B,eAAe;IACf,uBAAuB;IACvB,6BAA6B;IAC7B,mCAAmC;AACvC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0DAA0D;AAC9D;;;AAGA;CACC,yBAAyB;CACzB,4BAA4B;CAC5B,kBAAkB;AACnB;AACA,mFAAmF;;AAEnF;IACI,gCAAgC;IAChC,2BAA2B;AAC/B,WAAW;AACX,uBAAuB;AACvB;+BAC+B;AAC/B,kBAAkB;AAClB,4BAA4B;AAC5B,4CAA4C;AAC5C,yBAAyB;;AAEzB,mBAAmB;CAClB,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;AACA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,uBAAuB;IACvB,2BAA2B;IAC3B,2BAA2B;;AAE/B;AACA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;;AAEtB;AACA;IACI,eAAe;CAClB;;;AAGD;IACI,eAAe;AACnB;AACA;IACI,+BAA+B;IAC/B,oCAAoC;IACpC,iCAAiC;IACjC,sCAAsC;IACtC,8BAA8B;IAC9B,uBAAuB;IACvB,wBAAwB;IACxB,6BAA6B;IAC7B,eAAe;IACf,uBAAuB;IACvB,6BAA6B;IAC7B,mCAAmC;AACvC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,0DAA0D;AAC9D;;;AAGA;CACC,yBAAyB;CACzB,4BAA4B;CAC5B,kBAAkB;AACnB;AACA;IACI,oCAAoC;AACxC;;AAEA,gFAAgF;AAChF;IACI;;;;;;;;OAQG;EACL;;EAEA,oEAAoE;EACpE;IACE;;;;;;;;OAQG;AACP","sourcesContent":[".menuSearchOption{\r\n    display: flex;\r\n    position: relative;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    height: 100%;\r\n}\r\n.compactSelector{\r\n    position: relative;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 80%;\r\n    height: 70%;\r\n    \r\n}\r\n.compactSelectorAdmin{\r\n    position: relative;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    /* height: 70%;< */\r\n    /* top :10%; */\r\n}\r\n.compactSelectorIcon{\r\n    position: relative;\r\n    display: block;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100%;\r\n    /* height: 70%;< */\r\n    /* top :10%; */\r\n}\r\n.react-select__control{\r\n    border-color: var(--border-table-color) !important;\r\n    /* border-color: #ee085c; */\r\nwidth: 100%;\r\nheight: 100%;\r\n/* border-top: none !important;\r\nborder-left: none !important; */\r\nborder-radius: var(--border-radios-small);\r\nbackground-color: var(--white-color) !important;\r\ncolor: aliceblue !important;\r\n\r\nletter-spacing: 1px;\r\n text-align: center;\r\n}\r\n.react-select__input,.react-select__placeholder{\r\n    background-color: transparent !important;\r\n    color: var(--txt-color) !important;\r\n    border: none !important;\r\n    outline: 0 !important;\r\n    font-size: var(--font-size-small);\r\n}\r\n.react-select-container{\r\n    outline: 0 !important;\r\n    top: 5px;\r\n}\r\n.react-select-container-admin{\r\n    background: #FFF !important;\r\n    color: #003757;\r\n}\r\n.react-select-container-icon{\r\n    background: #FFF !important;\r\n    color: #003757;\r\n}\r\n.react-select__input-container,.react-select__single-value {\r\n    color: var(--txt-color) !important;\r\n    font-size: var(--font-size-small);\r\n}\r\n.react-select__indicator svg{\r\n    color: #088eee ;\r\n }\r\n\r\n.labelSelector{\r\n    /* font-weight: bold; */\r\n    position: absolute;\r\n    top: -25%;\r\n    z-index: 2;\r\n    /* color: #eaeaea; */\r\n    \r\n    /* color:  #c4c4c4; */\r\n    color: var(--main-color);\r\n}\r\n.labelSelectorAdmin{\r\n    position: absolute;\r\n    top: -30%;\r\n    color:  #003757;\r\n    z-index: 1;\r\n}\r\n.labelSelectorIcon{\r\n    position: absolute;\r\n    top: -30%;\r\n    color:  #003757;\r\n    z-index: 1;\r\n}\r\n.react-select__menu:hover{\r\n    cursor: pointer;\r\n}\r\n.react-select__menu{\r\n    /* border-color:#088eee !important;;\r\n    background-color:#030915 !important ;\r\n    color: #088eee !important; */\r\n    color: var(--txt-color) !important;\r\n    background-color: var(--white-color) !important;\r\n    border: 1px solid aliceblue !important;\r\n    align-items: center !important;\r\n    display: flex !important;\r\n    text-align: center !important;\r\n    cursor: pointer;\r\n    z-index: 3 !important;\r\n}\r\n.react-select__menu-list{\r\n    width: 100% !important;\r\n\r\n    z-index: 30 !important;\r\n}\r\n.react-host-select__menu-portal{\r\n    z-index: 30 !important;\r\n\r\n}\r\n.Whitereact-host-select__menu-portal{\r\n    z-index: 30 !important;\r\n}\r\n.react-select__option{\r\n    border-bottom-color: rgba(255, 255, 255, 0.127) !important;\r\n}\r\n/***************************** SELECTOR ADMIN **************************************/\r\n\r\n.react-select-admin__control{\r\n    border-color: #003757 !important;\r\n    /* border-color: #ee085c; */\r\nwidth: 100%;\r\nheight: 30px !important;\r\nborder-top: none !important;\r\nborder-left: none !important;\r\nborder-radius: 5px;\r\nborder-width: 2px !important;\r\n/* background-color: #00000029 !important; */\r\ncolor: #003757 !important;\r\n\r\nletter-spacing: 1px;\r\n text-align: left;\r\n min-height: unset !important;\r\n /* z-index: 999 !important; */\r\n}\r\n.react-select-admin__input,.react-select-admin__placeholder{\r\n    background-color: transparent !important;\r\n    color: #003757 !important;\r\n    border: none !important;\r\n    /* outline: 0 !important; */\r\n    font-size: large !important;\r\n\r\n}\r\n.react-select-container-admin{\r\n    outline: 0 !important;\r\n    /* top: 5px; */\r\n}\r\n\r\n.react-select-admin__input-container,.react-select-admin__single-value {\r\n    color: #003757 !important;\r\n    text-align: center;\r\n    font-size: small;\r\n    margin-bottom: 4px;\r\n\r\n}\r\n.react-select-admin__indicator svg{\r\n    color: #003757 ;\r\n }\r\n\r\n\r\n.react-select-admin__menu:hover{\r\n    cursor: pointer;\r\n}\r\n.react-select-admin__menu{\r\n    border-color:#003757 !important;;\r\n    background-color:#0065a0 !important ;\r\n    color: aliceblue !important;\r\n    border: 1px solid aliceblue !important;\r\n    align-items: center !important;\r\n    display: flex !important;\r\n    text-align: center !important;\r\n    cursor: pointer;\r\n    z-index: 999 !important;\r\n    position: absolute !important;\r\n    /* max-height:  100px !important; */\r\n}\r\n.react-select-admin__menu-list{\r\n    width: 100% !important;\r\n}\r\n.react-select-admin__option{\r\n    border-bottom-color: rgba(255, 255, 255, 0.127) !important;\r\n}\r\n\r\n\r\n.react-select-admin__placeholder{\r\n color: #c4c4c4 !important;\r\n font-size: medium !important;\r\n /* margin-left:; */\r\n}\r\n/***************************** SELECTOR ICON **************************************/\r\n\r\n.react-select-icon__control{\r\n    border-color: #003757 !important;\r\n    /* border-color: #ee085c; */\r\nwidth: 100%;\r\nheight: 30px !important;\r\n/* border-top: none !important;\r\nborder-left: none !important; */\r\nborder-radius: 5px;\r\nborder-width: 2px !important;\r\n/* background-color: #00000029 !important; */\r\ncolor: #003757 !important;\r\n\r\nletter-spacing: 1px;\r\n text-align: left;\r\n min-height: unset !important;\r\n /* z-index: 999 !important; */\r\n}\r\n.react-select-icon__input,.react-select-icon__placeholder{\r\n    background-color: transparent !important;\r\n    color: #003757 !important;\r\n    border: none !important;\r\n    /* outline: 0 !important; */\r\n    font-size: large !important;\r\n\r\n}\r\n.react-select-container-icon{\r\n    outline: 0 !important;\r\n    /* top: 5px; */\r\n}\r\n\r\n.react-select-icon__input-container,.react-select-icon__single-value {\r\n    color: #003757 !important;\r\n    text-align: center;\r\n    font-size: small;\r\n    margin-bottom: 4px;\r\n\r\n}\r\n.react-select-icon__indicator svg{\r\n    color: #003757 ;\r\n }\r\n\r\n\r\n.react-select-icon__menu:hover{\r\n    cursor: pointer;\r\n}\r\n.react-select-icon__menu{\r\n    border-color:#003757 !important;;\r\n    background-color:#ffffff !important ;\r\n    color: rgb(0, 81, 151) !important;\r\n    border: 1px solid aliceblue !important;\r\n    align-items: center !important;\r\n    justify-content: center;\r\n    display: flex !important;\r\n    text-align: center !important;\r\n    cursor: pointer;\r\n    z-index: 999 !important;\r\n    position: absolute !important;\r\n    /* max-height:  100px !important; */\r\n}\r\n.react-select-icon__menu-list{\r\n    width: 100% !important;\r\n}\r\n.react-select-icon__option{\r\n    border-bottom-color: rgba(255, 255, 255, 0.127) !important;\r\n}\r\n\r\n\r\n.react-select-icon__placeholder{\r\n color: #010b2c !important;\r\n font-size: medium !important;\r\n /* margin-left:; */\r\n}\r\n.rowIcon:hover{\r\n    background-color: var(--hover-color);\r\n}\r\n\r\n/* **************************** horizontal Movil****************************** */\r\n@media (min-width: 500px) and (max-width: 900px) {\r\n    /* .react-select-container-admin-gs{\r\n        top: 2%;\r\n    }\r\n    .react-select-admin-gs__control{\r\n        height: 20px !important;\r\n    }\r\n    .react-select-admin-gs__indicators{\r\n        height: 20px !important;\r\n    } */\r\n  }\r\n  \r\n  /* ****************************Movil****************************** */\r\n  @media (max-width: 500px) {\r\n    /* .react-select-container-admin-gs{\r\n        top: 2%;\r\n    }\r\n    .react-select-admin-gs__control{\r\n        height: 20px !important;\r\n    }\r\n    .react-select-admin-gs__indicators{\r\n        height: 20px !important;\r\n    } */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
